import { clearDashboardCache } from './dashboardCache';

// Preview as: a developer signs in as a made-up account to see the app from
// another role, or a club admin previews one of the club's roles from the
// Roles page. Their own sign-in is put aside here and restored on the way out,
// back to the page they started from.
const RETURN_KEY = 'tl-preview-return';
const RETURN_USER_KEY = 'tl-preview-return-user';
const LABEL_KEY = 'tl-preview-label';
const RETURN_TO_KEY = 'tl-preview-return-to'; // where Back to my account goes
const USER_KEY = 'tl-user';

const read = (k) => { try { return localStorage.getItem(k); } catch { return null; } };
const write = (k, v) => { try { v == null ? localStorage.removeItem(k) : localStorage.setItem(k, v); } catch { /* storage blocked */ } };

export const isPreviewing = () => Boolean(read(RETURN_KEY));
export const previewLabel = () => read(LABEL_KEY);

// The saved copy of who is signed in goes with the token, so a slow or failed
// check on arrival (say, the server restarting) doesn't sign them out
function switchTo(token, path, cachedUser = null) {
  write('token', token);
  write(USER_KEY, cachedUser);
  clearDashboardCache();
  window.location.assign(path);
}

export function startPreview({ token, role, label, returnTo = null }) {
  if (!isPreviewing()) {
    write(RETURN_KEY, read('token'));
    write(RETURN_USER_KEY, read(USER_KEY));
  }
  write(LABEL_KEY, label);
  write(RETURN_TO_KEY, returnTo);
  switchTo(token, role === 'child' ? '/child' : '/dashboard');
}

// Back to the developer's own account. Returns false when there's nothing to go back to.
export function exitPreview(path) {
  const back = read(RETURN_KEY);
  if (!back) return false;
  const backUser = read(RETURN_USER_KEY);
  const to = path || read(RETURN_TO_KEY) || '/preview-as';
  write(RETURN_TO_KEY, null);
  write(RETURN_KEY, null);
  write(RETURN_USER_KEY, null);
  write(LABEL_KEY, null);
  switchTo(back, to, backUser);
  return true;
}
